import { isValid, parseISO } from "date-fns";

export const getDateWithWhatsappFallback = (
  whatsappTimestampMs,
  fallbackDateString,
) => {
  const parsedWhatsappTimestamp = Number(whatsappTimestampMs);

  if (Number.isFinite(parsedWhatsappTimestamp)) {
    return new Date(parsedWhatsappTimestamp);
  }

  if (!fallbackDateString) {
    return null;
  }

  const parsedFallbackDate = parseISO(fallbackDateString);

  if (isValid(parsedFallbackDate)) {
    return parsedFallbackDate;
  }

  return null;
};

export const getMessageDate = (message) =>
  getDateWithWhatsappFallback(
    message?.whatsappTimestampMs,
    message?.createdAt,
  );

export const getTicketLastMessageDate = (ticket) => {
  const fallbackDateString =
    ticket?.lastMessageAt || ticket?.messages?.[0]?.createdAt || ticket?.updatedAt;

  return getDateWithWhatsappFallback(ticket?.lastMessageSortAt, fallbackDateString);
};